import { render } from "./LanguageSelectionPage.vue?vue&type=template&id=728ad42e&scoped=true"
import script from "./LanguageSelectionPage.vue?vue&type=script&lang=js"
export * from "./LanguageSelectionPage.vue?vue&type=script&lang=js"

import "./LanguageSelectionPage.vue?vue&type=style&index=0&id=728ad42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728ad42e"]])

export default __exports__